import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InfoTooltipComponent } from '@ui-kit/miscs/info-tooltip/info-tooltip.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormLabelComponent } from '../form-label/form-label.component';

export interface RadioButtonFcOptions {
    id: string;
    label: string;
    value: any;
    disabled?: boolean;
    tooltipText?: string;
}

@Component({
    selector: 'radio-button-fc',
    standalone: true,
    imports: [RadioButtonModule, ReactiveFormsModule, TranslateModule, InfoTooltipComponent, FormLabelComponent],
    templateUrl: './radio-button-fc.component.html',
    styleUrl: './radio-button-fc.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioButtonFcComponent {
    name = input.required<string>();
    control = input.required<FormControl>();
    options = input.required<RadioButtonFcOptions[]>();

    label = input<string>('');
    tooltipText = input<string>('');
    required = input<boolean>(false);

    inline = input<boolean>(true);

    onClick = output<void>();
}
